"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamingContainer = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Colors_1 = require("../../../../../Colors");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const common_1 = require("../../../../../common");
const server_1 = require("../../../../../server");
const Player_1 = require("./Player");
const functions_1 = require("../../functions");
const StreamingContainerStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	justify-content: flex-start;
	align-items: flex-start;

	/* 상단바: [다시보기 선택 드롭다운(학생에게 공개된 전체 목록)] [영상이 여럿이면 영상 선택] / 우측 X 닫기.
	 * 종전 아코디언 목록·붉은 닫기 문구 제거. 목록에서 클릭한 다시보기가 기본 선택되어 바로 재생된다. */
	.top_menubar {
		width: 100%;
		flex-shrink: 0;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 12px;
		padding: 8px 12px 8px 20px;
		min-height: 50px;

		.title-wrap {
			display: flex;
			align-items: center;
			gap: 14px;
			min-width: 0;
			flex: 1;

			.title {
				color: ${Colors_1.Colors.white};
				font-size: 16px;
				line-height: 24px;
				font-weight: 700;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.replay-selector {
				min-width: 0;
				flex: 1;
				max-width: 520px;
				z-index: 7;
			}

			.media-selector {
				flex-shrink: 0;
				z-index: 6;
			}
		}

		.close-btn {
			flex-shrink: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 36px;
			height: 36px;
			border-radius: 50%;
			background: transparent;
			border: none;
			cursor: pointer;

			&:hover {
				background: rgba(255, 255, 255, 0.12);
			}
		}
	}
	.fullscreen {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.video-wrap {
		flex: 1;
		position: relative;
		width: 100%;
		background-size: object-fit;
		background-repeat: no-repeat;
		display: flex;
		flex-direction: column;
		background-color: ${Colors_1.Colors.black};
		height: 100%;
		overflow: hidden;
		justify-content: center;
		align-items: flex-end;

		${props => props.$isMobile && ` justify-content: center; align-items: center;`}

		video {
			object-fit: contain;
			background-size: contain;
			background-repeat: no-repeat;
			width: 100%;
			position: absolute;
			z-index: 2;
			height: 100%;
		}

		video::after {
			content: attr(data-watermark);
			position: absolute;
			top: 10px;
			left: 10px;
			background: rgba(0, 0, 0, 0.5);
			color: white;
			padding: 4px 8px;
			font-size: 14px;
			border-radius: 4px;
			pointer-events: none;
			user-select: none;
			z-index: 2; /* ensure watermark is on top */
		}
	}

	.loading {
		position: absolute;
		font-size: 20px;
		color: ${Colors_1.Colors.white};

		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1;
	}

	.progress-bar-container {
		width: 100%;
		height: 10px; // 5px에서 10px로 증가
		background-color: rgba(255, 255, 255, 0.3);
		border-radius: 5px; // 2.5px에서 5px로 증가
		cursor: pointer;
		position: relative;
	}

	.full-progress-bar {
		height: 100%;
		background-color: #8bacff;
		border-radius: 5px; // 2.5px에서 5px로 증가
		margin: 0;
	}

	.progress-bar {
		width: 20px; // 12px에서 20px로 증가
		height: 20px; // 12px에서 20px로 증가
		background-color: #8bacff;
		border-radius: 50%;
		position: absolute;
		top: 50%;
		transform: translate(-50%, -50%);
		cursor: pointer;
	}

	.custom-controls {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 4;
	}

	/* 좌·우 더블탭 / 방향키 10초 이동 피드백 */
	.seek-hint {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		padding: 10px 18px;
		border-radius: 999px;
		background: rgba(0, 0, 0, 0.55);
		color: #fff;
		font-size: 15px;
		font-weight: 700;
		pointer-events: none;
		z-index: 5;

		&.back {
			left: 12%;
		}

		&.forward {
			right: 12%;
		}
	}

	.controls-container {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
		flex-direction: column;
		padding: 10px;
		transition: opacity 0.3s ease-in-out;
	}

	.controls-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		margin-top: 10px;
		> * {
			margin: 0;
		}
	}

	.left_wrap {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 20px; // 16px에서 20px로 증가

		.button {
			background: none;
			border: none;
			color: white;
			cursor: pointer;
			transition: transform 0.1s ease-in-out;
			outline: none;
			display: flex;
			align-items: center;

			&:hover {
				transform: scale(1.15); // 1.1에서 1.15로 증가
			}

			&:active {
				transform: scale(0.85); // 0.9에서 0.85로 감소
			}
		}
	}

	canvas {
		z-index: 3;
	}

	.speed-selector,
	.quality-selector {
		z-index: 5;
		select {
			background: rgba(0, 0, 0, 0.5);
			color: white;
			border: 1px solid rgba(255, 255, 255, 0.5);
			border-radius: 4px;
			padding: 6px 10px;
			font-size: 14px;
			margin-right: 15px;
			cursor: pointer;
			transition: all 0.3s ease;

			&:hover,
			&:focus {
				background: rgba(0, 0, 0, 0.7);
				outline: none;
			}

			option {
				background: #222;
			}
		}
	}

	.time-display {
		color: white;
		font-size: 15px; // 14px에서 16px로 증가
		line-height: 25px; // 23px에서 25px로 증가
		width: max-content;
		display: flex;
		align-items: center;
	}

	.volume-control {
		display: flex;
		align-items: center;

		&:hover & {
			min-width: 70px; // 60px에서 70px로 증가
			width: 140px; // 120px에서 140px로 증가
			opacity: 1;
			margin-left: 15px; // 12px에서 15px로 증가
		}
	}

	.volume-slider {
		width: 0;
		opacity: 0;
		transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out;

		.volume-control:hover & {
			min-width: 70px; // 60px에서 70px로 증가
			width: 140px; // 120px에서 140px로 증가
			opacity: 1;
			margin-left: 15px; // 12px에서 15px로 증가
		}

		-webkit-appearance: none;
		background: transparent;
		cursor: pointer;

		&::-webkit-slider-runnable-track {
			width: 100%;
			height: 6px; // 4px에서 6px로 증가
			cursor: pointer;
			background: #fff;
			border-radius: 3px; // 2px에서 3px로 증가
		}

		&::-webkit-slider-thumb {
			-webkit-appearance: none;
			width: 18px; // 12px에서 18px로 증가
			height: 18px; // 12px에서 18px로 증가
			border-radius: 50%;
			background: #fff;
			cursor: pointer;
			margin-top: -6px; // -4px에서 -6px로 조정
		}

		&:focus {
			outline: none;
		}
	}

	.screen-full-btn {
		color: rgb(255, 255, 255) !important;
		background: transparent !important;
		border: none !important;
		font-size: 16px !important;
		cursor: pointer;
		margin-right: 5px;
	}

	.empty {
		width: 100%;
    	height: 100%;
    	display: flex;
    	justify-content: center;
    	text-align: center;
    	gap: ${props => (props.$isDesktop ? '4px' : '2px')};
    	flex-wrap: wrap;
    	align-items: center;
	    align-content: center;
		font-size: ${props => (props.$isDesktop ? '20px' : '16px')};
	}
`;
let popupWindow = null; // 팝업 창을 저장하는 변수
const openPopupWithFallback = (url, options) => {
    // 팝업이 이미 열려있는 경우
    if (popupWindow && !popupWindow.closed) {
        popupWindow.focus(); // 기존 팝업 활성화
        return;
    }
    // 새로운 팝업 열기 시도
    popupWindow = window.open(url, '_blank', options);
    // 팝업이 차단되었는지 확인
    if (!popupWindow || popupWindow.closed || typeof popupWindow.closed === 'undefined') {
        alert('팝업이 차단되었습니다. 브라우저 설정을 확인하세요.');
    }
    else {
        popupWindow.focus(); // 팝업 활성화
    }
};
exports.StreamingContainer = react_1.default.memo(() => {
    const { isMobile, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [streaming_id, setStreaming_id] = react_1.default.useState();
    const [item, setItem] = react_1.default.useState();
    const videoRef = (0, react_1.useRef)();
    const [preview, setPreview] = react_1.default.useState();
    const [streamingUrl, setStreamingUrl] = react_1.default.useState();
    const [mobileStreamingUrl, setMobileStreamingUrl] = react_1.default.useState();
    const { data, refetch } = (0, server_1.useReplayList)({
        id: streaming_id,
    });
    // 상단 셀렉트박스용 — 현재 다시보기와 같은 클래스에서 이 사용자에게 조회되는 전체 다시보기 목록
    const { data: listData, refetch: refetchReplayList } = (0, server_1.useReplayList)({
        class_id: item?.class_id,
        limit: 200,
        orderby: ['creation_time DESC'],
    });
    react_1.default.useEffect(() => {
        if (item?.class_id)
            refetchReplayList();
    }, [item?.class_id]);
    const replayOptions = react_1.default.useMemo(() => {
        const items = listData?.items ?? [];
        const visible = items.filter(replay => replay.status !== 'hide');
        const options = visible.map(replay => ({ id: replay.id, title: replay.title }));
        // 목록 응답에 현재 항목이 없어도(권한·페이지 한계) 선택값은 항상 표시
        if (item && !options.some(option => option.id === item.id)) {
            options.unshift({ id: item.id, title: item.title });
        }
        return options;
    }, [listData, item?.id, item?.title]);
    // 셀렉트박스에서 다른 다시보기 선택 → 해당 영상으로 전환(URL 도 맞춰 둔다)
    const handlerSelectReplay = (option) => {
        if (!option?.id || option.id === streaming_id)
            return;
        setPreview(undefined);
        setStreamingUrl(undefined);
        setMobileStreamingUrl(undefined);
        setStreaming_id(option.id);
        try {
            window.history.replaceState(null, '', `/player/${option.id}`);
        }
        catch (err) {
            // 히스토리 갱신 실패는 재생과 무관
        }
    };
    react_1.default.useEffect(() => {
        const uuid = location.pathname.split('/').pop();
        if (uuid) {
            setStreaming_id(uuid);
        }
    }, []);
    react_1.default.useEffect(() => {
        if (!streaming_id)
            return;
        refetch();
    }, [streaming_id]);
    react_1.default.useEffect(() => {
        if (data) {
            const { items } = data;
            if (items && items.length > 0) {
                setItem(items[0]);
                return;
            }
        }
        setItem(undefined);
    }, [data]);
    // 영상 선택 단계 제거(2026-09 운영 요청): 목록에서 고른 다시보기의 첫 영상을 바로 재생한다.
    // 미디어가 여럿이면 상단바 드롭다운으로 전환(아코디언 목록 없음).
    react_1.default.useEffect(() => {
        const medias = item?.medias ?? [];
        if (medias.length === 0) {
            setPreview(undefined);
            return;
        }
        setPreview(prev => (prev && medias.some(media => media.id === prev.id) ? prev : medias[0]));
    }, [item?.id, item?.medias]);
    // 파일명 노출 삭제(2026-09 운영 요청) — 강의 제목만 남긴다.
    // 영상이 여러 개인 다시보기는 전환 수단이 필요해 '영상 N' 라벨로만 제공한다(파일명 미노출).
    // 닫기: 자체 플레이어가 떠 있으면 STOP_STREAMING 으로 Player 가 서버에 일시중지를 보낸 뒤 창을 닫는다
    // (종전엔 window.close() 만 호출해 시청시간이 서버에 남지 않았다). 플레이어가 없으면(로딩 전·kollus) 바로 닫는다.
    // 안전장치: 어떤 이유로든 3초 안에 안 닫히면 강제로 닫는다.
    const handlerClose = () => {
        const isPlayerMounted = !!(item && preview?.id && mediaServiceType !== 'kollus');
        if (isPlayerMounted) {
            APP.eventManager.publish('STOP_STREAMING');
            setTimeout(() => window.close(), 3000);
        }
        else {
            window.close();
        }
    };
    const mediaOptions = react_1.default.useMemo(() => (item?.medias ?? []).map((media, index) => ({ id: media.id, title: `영상 ${index + 1}` })), [item?.medias]);
    const mediaServiceType = (0, react_1.useMemo)(() => (item?.medias && item.medias.length > 0 ? item.medias[0]?.service_type : ''), [item?.medias]);
    (0, react_1.useEffect)(() => {
        if (mediaServiceType === 'kollus' && item.id && preview?.id) {
            (0, functions_1.fetchGetStreamingAuth)(item.id, preview?.id)
                .then((response) => {
                if (response.result) {
                    const streamingUrl = response.result.streaming_url;
                    if (!streamingUrl) {
                        console.error('Streaming URL is not available');
                        return;
                    }
                    setStreamingUrl(() => streamingUrl);
                    if (isMobile) {
                        const urlObj = new URL(streamingUrl, window.location.origin);
                        const baseUrl = urlObj.origin + urlObj.pathname;
                        setMobileStreamingUrl(() => baseUrl);
                        openPopupWithFallback(streamingUrl, 'width=800,height=600,scrollbars=no,resizable=no');
                    }
                }
            })
                .catch(error => {
                console.log(error);
            });
        }
        return () => {
            if (popupWindow) {
                popupWindow.close();
            }
        };
    }, [mediaServiceType, item?.id, preview?.id]);
    return (react_1.default.createElement(StreamingContainerStyled
    // ref={windowRef}
    , { "$isMobile": isMobile, "$isDesktop": isDesktop, id: "streaming-container", className: "show" },
        react_1.default.createElement("div", { className: "top_menubar", id: "top_menubar", style: { background: Colors_1.Colors.w_grey } },
            react_1.default.createElement("div", { className: "title-wrap" },
                replayOptions.length > 0 ? (react_1.default.createElement("div", { className: "replay-selector" },
                    react_1.default.createElement(common_1.DropDown, { className: "dropdown-live", noShowButtonArea: true, value: replayOptions.find(option => option.id === streaming_id) ?? replayOptions[0], list: replayOptions, setDropValue: handlerSelectReplay, styles: {
                            dropWrap: { minWidth: 200, maxWidth: 520, width: '100%' },
                            titleWrap: { background: Colors_1.Colors.transparent },
                            titleText: { color: Colors_1.Colors.white },
                            itemWrap: { maxHeight: 320, overflow: 'auto' },
                        }, option: { downIcon: { color: '#fff' } }, isDisable: false }))) : (react_1.default.createElement("p", { className: "title", title: item?.title }, item?.title ?? '')),
                mediaOptions.length > 1 ? (react_1.default.createElement("div", { className: "media-selector" },
                    react_1.default.createElement(common_1.DropDown, { className: "dropdown-live", noShowButtonArea: true, value: mediaOptions.find(option => option.id === preview?.id) ?? mediaOptions[0], list: mediaOptions, setDropValue: option => setPreview(item?.medias?.find(media => media.id === option.id)), styles: {
                            dropWrap: { minWidth: 160, maxWidth: 320 },
                            titleWrap: { background: Colors_1.Colors.transparent },
                            titleText: { color: Colors_1.Colors.white },
                        }, option: { downIcon: { color: '#fff' } }, isDisable: false }))) : null),
            react_1.default.createElement(common_1.Button, { className: "close-btn", option: {
                    buttonBeforeIcon: {
                        show: true,
                        name: 'close',
                        size: 22,
                        color: Colors_1.Colors.white,
                    },
                }, onClick: handlerClose })),
        !item ? (react_1.default.createElement("div", { className: "empty" },
            react_1.default.createElement("span", null, "\uB2E4\uC2DC\uBCF4\uAE30 \uC815\uBCF4\uB97C \uBD88\uB7EC\uC624\uB294 \uC911\uC785\uB2C8\uB2E4."))) : !preview?.id ? (react_1.default.createElement("div", { className: "empty" },
            react_1.default.createElement("span", null, "\uB4F1\uB85D\uB41C \uC601\uC0C1\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."))) : mediaServiceType === 'kollus' ? (isMobile ? (react_1.default.createElement("iframe", { style: { border: 'none' }, src: mobileStreamingUrl, width: "100%", height: "100%" })) : (react_1.default.createElement("iframe", { style: { border: 'none' }, src: streamingUrl, width: "100%", height: "100%" }))) : (react_1.default.createElement("div", { className: "video-wrap", ref: videoRef },
            react_1.default.createElement(Player_1.Player, { id: item.id, previewId: preview.id })))));
});
